const TrustRow = () => {
  const companies = ["TNO Defence", "Brave1", "techUK", "Estonian Defence and Aerospace Industry Association", "1991 Ventures", "FSG Global", "National Security Strategic Investment Fund"];
  return <section className="py-12 md:py-16 bg-background border-b border-border/50">
      <div className="container px-6">
        <p className="text-center text-sm text-muted-foreground mb-8">Collaborating Organisations:</p>
        <div className="flex flex-wrap items-center justify-center gap-8 md:gap-12">
          {companies.map(company => <div key={company} className="text-muted-foreground/60 font-display text-sm md:text-base font-medium tracking-wide uppercase hover:text-muted-foreground transition-colors duration-300">
              {company}
            </div>)}
        </div>
      </div>
    </section>;
};
export default TrustRow;